import React from 'react'
import InvoiceList from '../../../component/billing-payments/invoice/InvoiceList'

function Invoice() {
  return (
    <div className='page-body'>
     <InvoiceList/>
    </div>
  )
}

export default Invoice
